import { useContext } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { App } from './App';
import { BefGlobalContext } from '@beflam/bef-core';
import { AppList } from './pages/AppList';

export function AppRouter() {
  let sGlobal = useContext(BefGlobalContext);
  //现在不管是正式的还是测试的，都需要登录，这里只需要设置不同的host即可
  if (process.env.NODE_ENV === 'development') {
    sGlobal.config.host = 'http://192.168.2.61:5300';
  } else if (process.env.NODE_ENV === 'production') {
    sGlobal.config.host = '';
  }
  sGlobal.isSpa = true;

  const navigate = useNavigate();

  sGlobal.sessionTimeOutEvent.subscribe((result) => {
    // let commandUrlQuery = getUrlQueryParams(window.location.search);
    // // commandUrlQuery = getQuery(window.location.href.trim().replace("%25", "%").trim());
    // let extendUrl = "";
    // if (commandUrlQuery?.appid) {
    //   extendUrl += "?appid=" + commandUrlQuery.appid;
    // }
    // if (commandUrlQuery?.commandid) {
    //   if (extendUrl)
    //     extendUrl += "&commandid=" + commandUrlQuery.commandid;
    //   else
    //     extendUrl += "?commandid=" + commandUrlQuery.commandid;
    // }

    // if (commandUrlQuery?.pagemode) {
    //   if (extendUrl)
    //     extendUrl += "&pagemode=" + commandUrlQuery.pagemode;
    //   else
    //     extendUrl += "?pagemode=" + commandUrlQuery.pagemode;
    // }
    navigate('/login' + window.location.search);
  });

  return (
    <Routes>
      <Route path="/app" Component={AppList} />
      <Route path="/login" Component={Login} />
      <Route path="/" Component={App} />
    </Routes>
  );
}

export default AppRouter;
